import {ReactNode, useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {useMenuInnerContext} from './MenuInnerContext'
import moment from 'moment'
import {KTSVG} from '../../../../helpers'
import {TOKENS} from '../../../../../app/components/design-system'

const headerTitle: Record<string, ReactNode> = {
  '/dashboard': 'Dashboard',
  '/map': 'Mapa',
  '/sensors': 'Sensores',
  '/apps/companies-management/companies': 'Empresas',
  '/apps/measuring-box-management/measuring-box': 'Caixas',
  '/apps/projects-management/projects': 'Projetos',
  '/apps/operators-management/operators': 'Operadores',
  '/apps/indicators-management/indicators': 'Coordenadores',
  '/apps/managers-management/documents': 'Gerentes',
  '/apps/administrators-management/administrators': 'Administradores',
  '/apps/logs-management/logs': 'Históricos',
}

export function MenuInner() {
  const location = useLocation()
  const {
    dashboardStartDate, setDashboardStartDate,
    dashboardEndDate, setDashboardEndDate,
    today,
    isFetchingList,
    resetFetchingList,
    fullScreen,
    setFullScreen,
  } = useMenuInnerContext()

  const toggleFullScreen = () => {
    setFullScreen(!fullScreen)
  }

  function HandleDashboardParameters() {
    const [startDate, setStartDate] = useState(dashboardStartDate)
    const [startDateValid, setStartDateValid] = useState(true)
    const [endDate, setEndDate] = useState(dashboardEndDate)
    const [endDateValid, setEndDateValid] = useState(true)
    const [isDisabled, setIsDisabled] = useState(true)
    const [allGraphicsFetched, setAllGraphicsFetched] = useState(false)

    const handleDates = () => {
      resetFetchingList()
      setDashboardStartDate(startDate)
      setDashboardEndDate(endDate)
    }

    useEffect(() => {
      const startDateCheck = moment(startDate, 'YYYY-MM-DD', true).isValid() && moment(startDate, 'YYYY-MM-DD', true).isSameOrBefore(moment(today, 'YYYY-MM-DD', true))
      setStartDateValid(startDateCheck)

      const endDateCheck = moment(endDate, 'YYYY-MM-DD', true).isValid() && !moment(endDate, 'YYYY-MM-DD', true).isAfter(moment(today, 'YYYY-MM-DD', true)) && moment(endDate, 'YYYY-MM-DD', true).isSameOrAfter(moment(startDate, 'YYYY-MM-DD', true))
      setEndDateValid(endDateCheck)

      if (startDateCheck && endDateCheck) {
        if (dashboardStartDate !== startDate || dashboardEndDate !== endDate)
          setIsDisabled(false)
      } else {
        setIsDisabled(true)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate, endDate])

    useEffect(() => {
      if (dashboardStartDate !== startDate || dashboardEndDate !== endDate)
        setIsDisabled(false)
      else setIsDisabled(true)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dashboardStartDate, dashboardEndDate])

    useEffect(() => {
      const keys = Object.keys(isFetchingList)
      if (keys.length > 0) {
        if (keys.find((key) => isFetchingList[key])) {
          setAllGraphicsFetched(false)
          return
        }
      }
      setAllGraphicsFetched(true)

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFetchingList])

    const dateInputBase: React.CSSProperties = {
      border: `1px solid ${TOKENS.color.border}`,
      borderRadius: TOKENS.radius.chip,
      padding: '6px 10px',
      fontSize: 13,
      color: TOKENS.color.text,
      background: TOKENS.color.card,
      outline: 'none',
    }

    return (
      <div className='d-flex align-items-center' style={{ gap: TOKENS.spacing.md, flexWrap: 'wrap' }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: TOKENS.color.text, margin: 0 }}>
          Dashboard
        </h2>

        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: TOKENS.spacing.sm,
            background: TOKENS.color.card,
            border: `1px solid ${TOKENS.color.border}`,
            borderRadius: TOKENS.radius.card,
            padding: '6px 10px',
            boxShadow: TOKENS.shadow.card,
          }}
        >
          <span
            style={{
              fontSize: TOKENS.typography.label.size,
              fontWeight: TOKENS.typography.label.weight,
              textTransform: TOKENS.typography.label.transform,
              letterSpacing: TOKENS.typography.label.tracking,
              color: TOKENS.color.muted,
              paddingRight: 4,
            }}
          >
            Período
          </span>
          <input
            style={{ ...dateInputBase, borderColor: startDateValid ? TOKENS.color.border : TOKENS.color.severity.high.text }}
            type='date'
            id='dash-start-date'
            name='dashboard-start-date'
            lang='pt-BR'
            value={startDate}
            max={today}
            onChange={(event) => setStartDate(event.target.value)}
          />
          <span style={{ fontSize: 12, color: TOKENS.color.muted }}>até</span>
          <input
            style={{ ...dateInputBase, borderColor: endDateValid ? TOKENS.color.border : TOKENS.color.severity.high.text }}
            type='date'
            id='dash-end-date'
            name='dashboard-end-date'
            lang='pt-BR'
            value={endDate}
            min={startDate}
            max={today}
            onChange={(event) => setEndDate(event.target.value)}
          />
          <button
            onClick={handleDates}
            disabled={isDisabled}
            style={{
              border: 'none',
              background: isDisabled ? TOKENS.color.surface : TOKENS.color.action,
              color: isDisabled ? TOKENS.color.muted : '#fff',
              padding: '6px 14px',
              borderRadius: TOKENS.radius.chip,
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: 0.3,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            {allGraphicsFetched
              ? 'Aplicar'
              : <>Aguarde<span className='spinner-border spinner-border-sm align-middle' style={{ width: 12, height: 12 }}></span></>
            }
          </button>
        </div>

        <button
          type='button'
          onClick={toggleFullScreen}
          disabled={!allGraphicsFetched}
          title={fullScreen ? 'Reduzir gráficos' : 'Ampliar gráficos'}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: TOKENS.spacing.xs,
            background: TOKENS.color.card,
            border: `1px solid ${TOKENS.color.border}`,
            borderRadius: TOKENS.radius.card,
            padding: '8px 12px',
            cursor: allGraphicsFetched ? 'pointer' : 'not-allowed',
            opacity: allGraphicsFetched ? 1 : 0.5,
            fontSize: 12,
            fontWeight: 600,
            color: TOKENS.color.text,
            boxShadow: TOKENS.shadow.card,
          }}
        >
          <KTSVG
            path={fullScreen ? '/media/icons/duotune/general/zoom_minus.svg' : '/media/icons/duotune/general/zoom_plus.svg'}
            className='svg-icon-2 m-0 p-0'
          />
          <span>{fullScreen ? 'Reduzir' : 'Ampliar'}</span>
        </button>
      </div>
    )
  }

  return (
    <div className='d-flex align-items-center'>
      {location.pathname === '/dashboard' ? (
        <HandleDashboardParameters />
      ) : (
        <h2 style={{ fontSize: 22, fontWeight: 700, color: TOKENS.color.text, margin: 0 }}>
          {headerTitle[location.pathname]}
        </h2>
      )}
    </div>
  )
}
